import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngInputBase } from '../../inputs';

@Component({
  selector: 'ing-input-base',
  templateUrl: './input-base.component.html',
  styleUrls: ['./input-base.component.scss']
})
export class InputBaseComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngInputBase<any>;

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/input-base/input-base.component.ts